import {
  config
} from '../config';


const init = () => {
  // Header video add/remove on different screen sizes
  if (document.querySelector('video#header-video')) {
    const mql = window.matchMedia(`(min-width: ${config.breakpoint.smMax}px)`);
    
    const handleVideoResize = (e) => {
      if (e.matches) {
        setTimeout(() => {
          createVideoHeader();
        }, 100);
      }
    };
    
    mql.addEventListener('change', handleVideoResize);
    // Run immediately on init
    handleVideoResize(mql);
  }

};

const createVideoHeader = () => {

  // Define the video object this source is contained inside
  var sources = document.querySelectorAll('video#header-video source');
  var video = document.querySelector('video#header-video');
  for (var i = 0; i < sources.length; i++) {
    sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
  }

  video.load();
  video.muted = 'muted';
};

export {
  init
};